import service from './index'

const resourceMedals = service.resource('medal/search-rank/{ = medalId}{ = year}{ = month}{ = page}{ = size}')

export default {
  getMedals (medalId,year, month,page,size) {
    return resourceMedals.get({medalId: medalId,year:year,month:month,page:page,size:size})
  }
}




// WEBPACK FOOTER //
// ./src/services/medals.js